export default "__VITE_ASSET__CcR5gEND__"